/**
 * The Pinnacle mark: a triangulation station.
 *
 * Surveyors mark the high point of a piece of land with a triangle and a centre
 * point — the trig station. It means "the summit, and it has been measured."
 * That is the whole practice in one symbol, and it belongs to land rather than
 * to the generic mountain-peak logo the first pass used.
 *
 * Distinct from Fourcities' quadrant mark (that one is the region; this one is
 * the surveyed point) even though it's the same agent underneath. The centre
 * point is redline, because the point is the thing you're meant to look at.
 */

interface Props {
  className?: string;
}

export default function BrandMark({ className = '' }: Props) {
  return (
    <span
      className={`relative flex shrink-0 items-center justify-center overflow-hidden bg-blueprint ${className}`}
      aria-hidden="true"
    >
      <svg viewBox="0 0 24 24" className="h-[68%] w-[68%]" fill="none">
        {/* Station triangle */}
        <path
          d="M12 4.5L20 19H4Z"
          stroke="#FFFFFF"
          strokeWidth="1.3"
          strokeLinejoin="miter"
        />
        {/* Sight lines to the vertices, drawn light — how the point is fixed */}
        <path
          d="M12 14.2L12 4.5M12 14.2L4 19M12 14.2L20 19"
          stroke="#FFFFFF"
          strokeOpacity="0.32"
          strokeWidth="0.7"
        />
        {/* The measured point */}
        <circle cx="12" cy="14.2" r="1.9" fill="#B23A2E" />
      </svg>
    </span>
  );
}
